import { ReactNode, useCallback } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getAcademicOffers } from '../api';
import {
  CeAcademicOfferFilters,
  CeAcademicOfferPaginatedResponse,
} from '../types';

const {
  FetchProvider: AcademicOffersProvider,
  FetchConsumer: AcademicOffersConsumer,
  useFetch: useAcademicOffers,
} = createFetchContext<
  CeAcademicOfferFilters,
  CeAcademicOfferPaginatedResponse
>();

interface Props {
  children: ReactNode;
  defaultQuery?: CeAcademicOfferFilters;
  fetchImmediately?: boolean;
}

export const AcademicOffersLoader = ({
  children,
  defaultQuery = { page: 1, items_per_page: 10 },
  fetchImmediately = true,
}: Props) => {
  const requestFn = useCallback(
    (filters?: CeAcademicOfferFilters) => getAcademicOffers(filters ?? {}),
    [],
  );

  return (
    <AcademicOffersProvider
      request={requestFn}
      defaultQuery={defaultQuery}
      fetchImmediately={fetchImmediately}
    >
      {children}
    </AcademicOffersProvider>
  );
};

export { AcademicOffersConsumer, AcademicOffersProvider, useAcademicOffers };
